import { render } from "./EmptyMessage.vue?vue&type=template&id=133aa05c&scoped=true"
import script from "./EmptyMessage.vue?vue&type=script&lang=js"
export * from "./EmptyMessage.vue?vue&type=script&lang=js"

import "./EmptyMessage.vue?vue&type=style&index=0&id=133aa05c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133aa05c"]])

export default __exports__